import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryStatusList extends BaseModelAPI {

	static entity = 'deliverystatuslist'
	static entityName = 'deliverystatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
